var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatActions = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 8.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 8.5,
  r: 1
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatActions);
export default ForwardRef;